export default "__VITE_ASSET__89143003__"